module.exports = __webpack_public_path__ + "static/img/slider-66.880f1f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-66.jpg
// module id = N0hh
// module chunks = 0